import type { ContentChatbot } from '~/models/Content/ContentChatbot'
import { ref } from 'vue'
import { PendoTrackName } from '~/models/Pendo'
import usePendo from '~/composables/usePendo'

export function useChatbotSubmit(
  bot: ContentChatbot | undefined,
  prompt: (value: string, initial?: boolean) => Promise<void>,
) {
  const interactions = ref<number>(0)
  const { pendoTrack, pendoFlushNow } = usePendo()

  const submit = (value: string) => {
    const trimmedValue = value.trim()
    if (!trimmedValue) {
      return
    }

    interactions.value++
    pendoTrack(PendoTrackName.Chat, {
      title: document.title,
      url: window.location.href,
      interactions: interactions.value,
      locationId: bot?.locationId ?? 0,
    })

    prompt(trimmedValue, false)
    pendoFlushNow()
  }

  return { submit, interactions }
}
